import { FC } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import GenInputLabel from "../GenInputLabel/GenInputLabel";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface GenInputRowProps {
  label?: string;
  error?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  fullScreen?: boolean;
  expanded?: number;
  extended?: number;
  helperText?: string;
  top?: boolean;
  children: React.ReactNode;
}

export const GenInputRow: FC<GenInputRowProps> = (props) => {
  const {
    expanded = 0,
    extended = 0,
    fullWidth,
    fullScreen,
    top,
    label,
    error,
    required,
    children,
    helperText,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      spacing={2}
      alignItems={top ? "flex-start" : "center"}
      mb={1}
    >
      <Grid
        item
        sm={fullScreen ? 2 + expanded : 4 + expanded}
        xs={12}
        textAlign={matches ? "left" : "right"}
        marginTop={-0.2}
        marginBottom={matches ? -2 : 0}
      >
        {label && (
          <GenInputLabel required={required} error={error}>
            {label}
          </GenInputLabel>
        )}
      </Grid>
      <Grid
        item
        sm={fullWidth || fullScreen ? 8 - expanded + extended : 4 + extended}
        xs={12}
      >
        <Box>{children}</Box>
        {helperText && (
          <Typography
            variant="caption"
            color={error ? "red" : "secondary"}
            mt={-0.5}
          >
            {helperText}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default GenInputRow;
